module.exports = __webpack_public_path__ + "static/media/care_hawaii6.0e82cce5.jpg";